import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
// import { history } from 'redux/dashboard/node_modules/index'
import * as Services from 'services/dashboard'
import actions from './actions'

export function* FETCH_USER() {
  yield put({
    type: actions.SET_STATE,
    payload: {
      userLoading: true,
    },
  })
  const response = yield call(Services.fetchUserStats)
  if (!response.error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        userLoading: false,
        userStats: response.data.usersStats,
      },
    })
  } else if (response.error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        userLoading: false,
      },
    })
    showError(response.message)
  }
}

export function* FETCH_BIZ() {
  yield put({
    type: actions.SET_STATE,
    payload: {
      bizLoading: true,
    },
  })
  const response = yield call(Services.fetchBusinessStats)
  if (!response.error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        bizLoading: false,
        bizStats: response.data.businessesStats,
      },
    })
  } else if (response.error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        bizLoading: false,
      },
    })
    showError(response.message)
  }
}

export function* WALLET_STATS() {
  yield put({
    type: actions.SET_STATE,
    payload: {
      WalletLoading: true,
    },
  })
  const response = yield call(Services.WalletStatistics)

  if (!response.error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        WalletLoading: false,
        WalletStats: response.data,
      },
    })
  } else if (response.error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        WalletLoading: false,
      },
    })
    showError(response.message)
  }
}

function showError(msg) {
  notification.error({
    message: 'Try again',
    description: msg,
  })
}

export function* FETCH_SUB_AGENTS({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      isSubAgentsLoading: true,
    },
  })
  const response = yield call(Services.fetchSubAgents, payload.agentId)
  if (response && !response.error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        subAgents: response.data.agents,
        isSubAgentsLoading: false,
      },
    })
  } else {
    yield put({
      type: actions.SET_STATE,
      payload: {
        isSubAgentsLoading: false,
      },
    })
  }
}

export function* CREATE_SUB_AGENT({ payload }) {
  const response = yield call(Services.createSubAgent, payload.agentId, payload.data)
  if (response && !response.error) {
    if (payload.callback) payload.callback()
    yield put({
      type: actions.FETCH_SUB_AGENTS,
      payload: { agentId: payload.agentId },
    })
  }
}

export function* UPDATE_SUB_AGENT({ payload }) {
  const response = yield call(
    Services.updateSubAgent,
    payload.agentId,
    payload.subAgentId,
    payload.data,
  )
  if (response && !response.error) {
    if (payload.callback) payload.callback()
    yield put({
      type: actions.FETCH_SUB_AGENTS,
      payload: { agentId: payload.agentId },
    })
  }
}

export function* ASSIGN_MERCHANT_TO_SUB_AGENT({ payload }) {
  const response = yield call(
    Services.assignMerchantToSubAgent,
    payload.agentId,
    payload.subAgentId,
    payload.data,
  )
  if (response && !response.error) {
    if (payload.callback) payload.callback()
    yield put({
      type: actions.FETCH_SUB_AGENTS,
      payload: { agentId: payload.agentId },
    })
  }
}

export function* REMOVE_MERCHANT_FROM_SUB_AGENT({ payload }) {
  const { agentId, subAgentId, businessId, callback } = payload
  const response = yield call(Services.removeMerchantFromSubAgent, agentId, subAgentId, businessId)
  if (response && !response.error) {
    if (callback) callback(response)
    yield put({
      type: actions.FETCH_SUB_AGENTS,
      payload: { agentId },
    })
  }
}

export function* FETCH_SALES_AGENT_BY_ID({ payload }) {
  const response = yield call(Services.fetchSalesAgentById, payload.agentId)
  if (response && !response.error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        selectedAgent: response.data,
      },
    })
  }
}

export function* FETCH_AGENT_COMMISSION({ payload }) {
  const { agentId, month, year, includeDetails = false } = payload
  yield put({ type: actions.SET_STATE, payload: { commissionLoading: true } })
  const response = yield call(
    Services.fetchMonthlyAgentCommission,
    agentId,
    month,
    year,
    includeDetails,
  )
  if (response && !response.error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        commissionLoading: false,
        agentCommission: response.data || {},
      },
    })
  } else {
    yield put({ type: actions.SET_STATE, payload: { commissionLoading: false } })
  }
}

export function* FETCH_AGENT_YEARLY_COMMISSION({ payload }) {
  const { agentId, year } = payload
  yield put({ type: actions.SET_STATE, payload: { commissionLoading: true } })
  const response = yield call(Services.fetchYearlyAgentCommission, agentId, year)
  if (response && !response.error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        commissionLoading: false,
        yearlyAgentCommission: response,
      },
    })
  } else {
    yield put({ type: actions.SET_STATE, payload: { commissionLoading: false } })
  }
}

export function* FETCH_MERCHANT_FEE({ payload }) {
  const { businessId } = payload
  yield put({ type: actions.SET_STATE, payload: { merchantFeeLoading: true } })
  const response = yield call(Services.fetchRateDetails, businessId)
  if (response && !response.error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        merchantFeeLoading: false,
        merchantFee: response.data?.processingFee || [],
      },
    })
  } else {
    yield put({ type: actions.SET_STATE, payload: { merchantFeeLoading: false } })
  }
}

export function* FETCH_PAYOUT_HISTORY({ payload }) {
  yield put({ type: actions.SET_STATE, payload: { isPayoutHistoryLoading: true } })
  const response = yield call(Services.fetchAgentPayouts, payload.agentId)
  if (response && !response.error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        payoutHistory: response.data.payouts,
        isPayoutHistoryLoading: false,
      },
    })
  } else {
    yield put({ type: actions.SET_STATE, payload: { isPayoutHistoryLoading: false } })
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.GET_USER_STATS, FETCH_USER),
    takeEvery(actions.GET_BUSINESS_STATS, FETCH_BIZ),
    takeEvery(actions.GET_WALLET_STATISTICS, WALLET_STATS),
    takeEvery(actions.FETCH_SUB_AGENTS, FETCH_SUB_AGENTS),
    takeEvery(actions.CREATE_SUB_AGENT, CREATE_SUB_AGENT),
    takeEvery(actions.UPDATE_SUB_AGENT, UPDATE_SUB_AGENT),
    takeEvery(actions.ASSIGN_MERCHANT_TO_SUB_AGENT, ASSIGN_MERCHANT_TO_SUB_AGENT),
    takeEvery(actions.FETCH_SALES_AGENT_BY_ID, FETCH_SALES_AGENT_BY_ID),
    takeEvery(actions.FETCH_AGENT_COMMISSION, FETCH_AGENT_COMMISSION),
    takeEvery(actions.FETCH_AGENT_YEARLY_COMMISSION, FETCH_AGENT_YEARLY_COMMISSION),
    takeEvery(actions.FETCH_MERCHANT_FEE, FETCH_MERCHANT_FEE),
    takeEvery(actions.FETCH_PAYOUT_HISTORY, FETCH_PAYOUT_HISTORY),
    takeEvery(actions.REMOVE_MERCHANT_FROM_SUB_AGENT, REMOVE_MERCHANT_FROM_SUB_AGENT),
  ])
}
